module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Remove procedure?","notifyRemove":"Procedure removed successfully"},"es":{"dialogTitle":"¿Eliminar procedimiento?","notifyRemove":"Procedimiento eliminado con éxito"}}')
  delete Component.options._Ctor
}
